/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { StudentEngagementRecord } from './studentEngagementRecord';
import type { StudentEngagementRosterInfoStateCounts } from './studentEngagementRosterInfoStateCounts';

/**
 * Container for the engagement roster including stats
 */
export interface StudentEngagementRosterInfo {
  records: StudentEngagementRecord[];
  totalCount: number;
  stateCounts?: StudentEngagementRosterInfoStateCounts;
}
